// src/components/CalendarGrid/utils.js
// Shared utility functions used by WeekView and DayView.

export function isToday(date) {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

export function dateToDecimalHour(date) {
  return date.getHours() + date.getMinutes() / 60;
}

export function eventsOverlap(a, b) {
  return a.startHour < b.endHour && b.startHour < a.endHour;
}

// Assigns a column index to each event so overlapping events sit side-by-side.
// Returns [{ event, col, totalCols }].
export function layoutEventsForDay(dayEvents) {
  if (!dayEvents.length) return [];

  const sorted = [...dayEvents].sort((a, b) => a.startHour - b.startHour);

  // columns[i] = the last event placed in lane i
  const lanes = [];
  const placed = sorted.map(event => {
    let col = 0;
    while (lanes[col] && eventsOverlap(lanes[col], event)) col++;
    lanes[col] = event;
    return { event, col };
  });

  const maxCol = Math.max(...placed.map(r => r.col)) + 1;
  return placed.map(r => ({ ...r, totalCols: maxCol }));
}

export function formatTime(date) {
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
